import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "./MainLayout";
import ProLayout from "./ProLayout";

function App() {
  return (
    <MainLayout />
  );
}

export default App;
